<div *ngIf="isIE" class="IEmesssage">
  <i class="fab fa-internet-explorer fa-3x"></i>
  <p class="mb-0">{{ 'copy.html.IENotSupported' | copy | async }}</p>
</div>
